import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userApi } from "@repo/api";
import { Logger } from "@saviynt/common";
import { userQueryKeys } from "../../../pages/IspmUsers/queryKeys";

export const useEnableUser = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess } = useMutation({
    mutationFn: (payload: { email: string }) => userApi.enableUser(payload),
    onError: (error) => {
      Logger.error("Error enabling user:", error);
    },
    onSuccess: (data) => {
      Logger.log("Successfully enabled user:", data);
      queryClient.invalidateQueries({ queryKey: userQueryKeys.lists() });
    },
  });

  return { mutate, isError, isSuccess };
};
